/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
var win=typeof window!=="undefined"?window:undefined;export{win as w};